export interface SurfboardWebhookMetadata {
  eventId: string;
  created: number;
  retryAttempt: number;
  webhookEventId: string;
}

export interface SurfboardMerchantWebhookData {
  applicationId: string;
  applicationStatus: string;
  corporateId: string;
  companyName: string;
  merchantId?: string;
  storeId?: string;
}

export interface SurfboardMerchantWebhook {
  eventType: string;
  metadata: SurfboardWebhookMetadata;
  data: SurfboardMerchantWebhookData;
}